import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const sections = [
  {
    title: '1. 個人情報の取り扱いについて',
    content: '株式会社Peach（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、個人情報の保護に関する法律（個人情報保護法）を遵守し、適切な取り扱いに努めます。',
  },
  {
    title: '2. 個人情報の利用目的',
    content: '当社は、収集した個人情報を以下の目的で利用します。\n・お問い合わせへの回答・対応\n・サービスのご提供およびご案内\n・契約の履行および管理\n・法令に基づく対応',
  },
  {
    title: '3. 個人情報の第三者提供',
    content: '当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n・お客様の同意がある場合\n・法令に基づく場合\n・人の生命・身体・財産の保護のために必要な場合',
  },
  {
    title: '4. 個人情報の安全管理',
    content: '当社は、個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。',
  },
  {
    title: '5. 個人情報の開示・訂正・削除',
    content: 'お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご請求の際は、お問い合わせフォームよりご連絡ください。',
  },
  {
    title: '6. Cookieの使用について',
    content: '当社のウェブサイトでは、サービス向上のためCookieを使用する場合があります。ブラウザの設定によりCookieを無効にすることができますが、一部のサービスが利用できなくなる場合があります。',
  },
  {
    title: '7. プライバシーポリシーの変更',
    content: '当社は、必要に応じて本プライバシーポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。',
  },
  {
    title: '8. お問い合わせ窓口',
    content: '個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください。\n\n株式会社Peach\n所在地：大阪府大阪市浪速区敷津西１－５－２０ ラフィナート７０４号室\n代表者：山本 萌々子\n電話番号：090-6901-0787\nメールアドレス：accounting@peach-sys.com\nお問い合わせ：当サイトのお問い合わせフォームよりご連絡ください',
  },
];

export default function PrivacyPage() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Navbar />
      <section className="pt-36 pb-24 bg-gradient-to-b from-pink-50/60 to-white">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-black text-gray-800 mb-3">プライバシーポリシー</h1>
          </div>
          <div className="bg-white rounded-2xl border border-gray-100 p-8 md:p-12 flex flex-col gap-8">
            {sections.map((s) => (
              <div key={s.title}>
                <h2 className="text-base font-bold text-pink-500 mb-3">{s.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line">{s.content}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
